import React from 'react';

export default class Formitem extends React.Component {
	render(){
    /*if(this.props.large){
      return (
        <div className="item form-group">
          <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">
            {this.props.name}
            
            {
              this.props.must ?
                <span className="required">*</span>
              : null
            }
          </label>
          <div className="col-md-9 col-sm-9 col-xs-12">
              
          </div>
      </div>
        );
    }*/
		return (
      <div className="item form-group" style={{overflow: "auto"}}>
        <label className="control-label col-md-3 col-sm-3 col-xs-12">
            {this.props.name}
            
            {
              this.props.must ?
                <span className="required">*</span>
              : null
            }
        </label>
        <div className="col-md-8 col-sm-8 col-xs-12">
            {this.props.children}
        </div>
      </div>);
	}
}


// WEBPACK FOOTER //
// ./src/components/FormItem.js